/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="134.89"
        height="82.33"
        viewBox="0 0 134.89 82.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M118.67 29.73a1 1 0 0 1 1.95.43v.11L117.3 42.1a1.023 1.023 0 0 1-2-.43v-.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M94.55 35.72a1.24 1.24 0 0 1 1.42-.89h.12l20.58 5.76a1.25 1.25 0 0 1-.55 2.44h-.13l-20.52-5.76a1.25 1.25 0 0 1-.92-1.55ZM17.08 0h.46l29.84 8.42a1.25 1.25 0 0 1-.55 2.44h-.16L17.05 2.49 3.86 3.88l10.54 8 30.47 8.61a1.27 1.27 0 0 1 .9 1.42v.12a1.26 1.26 0 0 1-1.42.9h-.12l-30.7-8.62a.86.86 0 0 1-.29-.13l-.19-.12L.78 4.67.7 4.6a1.67 1.67 0 0 1-.38-2.33 1.62 1.62 0 0 1 1.07-.67h.28ZM97.08 23.67a1.24 1.24 0 0 1 1.42-.89h.17l21.37 6a1.25 1.25 0 0 1-.55 2.44h-.13l-21.37-6a1.26 1.26 0 0 1-.91-1.55Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M118.4 29.67a1.23 1.23 0 0 1 1.41-.9h.13l12.55 3.52a3.33 3.33 0 0 1 2.33 3.89v.18l-2.21 7.88a3.32 3.32 0 0 1-3.94 2.33h-.18l-12.55-3.52a1.25 1.25 0 0 1 .55-2.43h.18l12.55 3.53a.81.81 0 0 0 .94-.45v-.1l2.21-7.89a.8.8 0 0 0-.45-.94h-.1l-12.55-3.52a1.27 1.27 0 0 1-.83-1.57Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M84.43 19.07 80.77 36.9a7.881 7.881 0 0 0 15.44 3.17l3.66-17.83a7.89 7.89 0 0 0-5.89-9.25l-.24-.06a7.9 7.9 0 0 0-9.31 6.14Zm8.8-3.69a5.4 5.4 0 0 1 4.19 6.35l-3.66 17.83a5.38 5.38 0 0 1-10.54-2.16l3.66-17.83a5.41 5.41 0 0 1 6.14-4.23Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="m72.08 13.21-4.32 21a7.881 7.881 0 0 0 15.44 3.17l4.32-21a7.9 7.9 0 0 0-5.89-9.25h-.25a7.89 7.89 0 0 0-9.3 6.08Zm8.82-3.72a5.39 5.39 0 0 1 4.18 6.37l-4.32 21a5.383 5.383 0 0 1-10.54-2.19l4.32-21a5.37 5.37 0 0 1 6.34-4.22Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M46.19 7.58a7.87 7.87 0 0 1 14.75-2v.09l.1-.13a7.89 7.89 0 0 1 7.41-2.74h.22a7.9 7.9 0 0 1 6.18 9.06v.25l-4.64 22.64a1.25 1.25 0 0 1-2.47-.37v-.13l4.66-22.58a5.38 5.38 0 0 0-10.47-2.38v.22l-4.26 20.74a1.25 1.25 0 0 1-1.48 1 1.24 1.24 0 0 1-1-1.33v-.14l4-19.51a5.383 5.383 0 1 0-10.5-2.38v.22l-3.57 17.14a1.25 1.25 0 0 1-1.46 1 1.24 1.24 0 0 1-1-1.38v-.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M16.22.97a1.023 1.023 0 0 1 2 .43v.11l-3.34 11.82a1 1 0 0 1-1.25.68 1 1 0 0 1-.7-1.1v-.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M94.67 38.98a1.24 1.24 0 0 1 1.37 1.06 31.4 31.4 0 0 1-.38 10.72c-1.36 6.63-4.62 12.38-8.85 15.82l-.32.25-.44 14.22a1.25 1.25 0 0 1-1.36 1.13 1.24 1.24 0 0 1-1.13-1.13v-.13l.44-14.2v-.38a2.41 2.41 0 0 1 .92-1.48c3.89-3 7-8.35 8.25-14.59a28.91 28.91 0 0 0 .36-9.86 1.24 1.24 0 0 1 1.05-1.42ZM67.67 34.67a1.24 1.24 0 0 1 1.47-1 1.26 1.26 0 0 1 1 1.48 7.93 7.93 0 0 1-4.61 5.65 1.26 1.26 0 0 1-1.65-.65 1.24 1.24 0 0 1 .65-1.65 5.41 5.41 0 0 0 3.14-3.83Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M42.55 24.9a7.82 7.82 0 0 1 10.71 0l.24.23 7.2 7.61 2.94 3.15 1.12 1.23.43.5.07.08a8.14 8.14 0 0 1 1.82 6.72 8.61 8.61 0 0 1-3.07 4.77l-.25.19c-2.68 2.11-6.26 2.16-10.31-.7l-.28-.2L45.72 43a1.25 1.25 0 0 1 1.36-2.09l.12.07 7.45 5.51c3.18 2.35 5.55 2.41 7.46 1l.17-.13a6.08 6.08 0 0 0 2.39-3.49 5.5 5.5 0 0 0-1.19-4.38l-.21-.28-.17-.21-.65-.72-1.53-1.61-4.67-5-4.58-4.78-.19-.19a5.31 5.31 0 0 0-2.28-1.21l-.26-.06a5.33 5.33 0 0 0-4.51 1.14l-.19.17-11.69 11.23a5.55 5.55 0 0 0-.31 7.67l9.19 10.03a17.82 17.82 0 0 1 4.32 11.61v.44L45.43 81a1.26 1.26 0 0 1-1.22 1.28 1.24 1.24 0 0 1-1.28-1.21v-.13l.32-13.28a15.32 15.32 0 0 0-3.42-10l-.26-.3-9-9.91a8 8 0 0 1 0-11.17l.19-.19Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FistHoldingPencilIcon';

export default Icon;
